<template>
  <g>
    <path
      d="M7 8.00018C6.45 8.00018 6 8.45018 6 9.00018V15.0002C6 16.1002 6.9 17.0002 8 17.0002H16C16.55 17.0002 17 16.5502 17 16.0002C17 15.4502 16.55 15.0002 16 15.0002H8V9.00018C8 8.45018 7.55 8.00018 7 8.00018Z"
    />
    <path
      d="M20 3.00018H12C10.9 3.00018 10 3.90018 10 5.00018V11.0002C10 12.1002 10.9 13.0002 12 13.0002H20C21.1 13.0002 22 12.1002 22 11.0002V5.00018C22 3.90018 21.1 3.00018 20 3.00018ZM19.5 11.0002H12.5C12.22 11.0002 12 10.7802 12 10.5002V7.00018H20V10.5002C20 10.7802 19.78 11.0002 19.5 11.0002Z"
    />
    <path
      d="M3 12.0002C2.45 12.0002 2 12.4502 2 13.0002V19.0002C2 20.1002 2.9 21.0002 4 21.0002H12C12.55 21.0002 13 20.5502 13 20.0002C13 19.4502 12.55 19.0002 12 19.0002H4V13.0002C4 12.4502 3.55 12.0002 3 12.0002Z"
    />
  </g>
</template>
